import { Theme } from '@mui/material/styles'

export default function Popover(theme: Theme) {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.dropdown,
          borderRadius: 16,
          border: `1px solid ${theme.palette.grey[500_12]}`
        }
      }
    }
  }
}
